import { useSelector } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import WordsPractice from 'components/WordsPractice/WordsPractice'
import useThunkDispatch from 'hooks/useThunkDispatch'
import { routes } from 'routes/RouterStackComponent'
import {
  selectCurrentStudySet,
  selectDifficultWordsAndMasteredCount,
  setCurrentStudySetId
} from 'store/services/Exercise'

// [feature/pronunciation-pro]: add data fetching when a page is reloaded
const ReadingLevelUpExercise: React.FC<RouteComponentProps<{ practiceSetType: string }>> = (props) => {
  const dispatch = useThunkDispatch()
  const { practiceSetType } = props.match.params

  const currentStudySet = useSelector(selectCurrentStudySet)
  const { difficultWords } = useSelector(selectDifficultWordsAndMasteredCount)

  const isStudySet = practiceSetType === 'custom_set' && currentStudySet

  return (
    <WordsPractice
      isReadingLevelUp={!isStudySet}
      studySetId={isStudySet ? currentStudySet!._id : undefined}
      numberOfWordsToPractice={isStudySet ? currentStudySet!.words.length : 5}
      words={isStudySet ? currentStudySet!.words : difficultWords}
      practiceSetType={practiceSetType}
      onFinishPractice={() => {
        dispatch(setCurrentStudySetId(null))
        props.history.push(routes.pronunciation)
      }}
    />
  )
}

export default withRouter(ReadingLevelUpExercise)
